import {TypeOption} from "@ngx-formly/core/lib/models";
import {DialogNewContentHeaderFormlyComponent} from "../formly/dialog-new-content-header-formly/dialog-new-content-header-formly.component";

export const DialogFormlyType: TypeOption[] = [
  { name: 'dialog-new-content-header', component: DialogNewContentHeaderFormlyComponent },
];
